import { Card, Box, Icon, Text, Title } from '@nimbus-ds/components';
import { ChevronRightIcon, LocationIcon } from '@nimbus-ds/icons';

function SourceDestinationCardSkeleton() {
  return (
    <Card>
      <Card.Header>
        <Title.Skeleton as="h3" width="200px" />
      </Card.Header>
      <Card.Body>
        <Box display="flex" gap="4" alignItems="flex-start">
          <LocationSkeleton />
          <Box alignSelf="center">
            <Icon source={<ChevronRightIcon />} color="neutral-textLow" />
          </Box>
          <LocationSkeleton />
        </Box>
      </Card.Body>
    </Card>
  );
}

function LocationSkeleton() {
  return (
    <Box display="flex" gap="2" flex="1" flexDirection="column">
      <Text.Skeleton width="80px" />
      <Box display="flex" gap="2">
        <Icon color="neutral-textHigh" source={<LocationIcon />} />
        <Text.Skeleton width="120px" />
      </Box>
      <Text.Skeleton width="150px" />
    </Box>
  );
}

export default SourceDestinationCardSkeleton;
